import { AlertMessage, AlertType, ButtonType, CustomButton, Select, TextInput } from 'soprasteria-ui-library';
import * as React from 'react';
import { IAddOrthodonticReferralTherapy, IOrthodonticReferralICD10Code, IOrthodonticReferralPatientTreatment, IOrthodonticReferralTherapy } from '../../../../models/IOrthodonticReferral';
import { setMessage } from '../../../../helpers/MessageHelper';
import { OrthodonticReferralICD10Codes } from './OrthodonticReferralICD10Codes';
import { OrthodonticReferralTreatments } from './OrthodonticReferralTreatments';
import { useAuth } from '../../../../App';
import { OrthodonticReferralTreatmentApi } from '../../../../api/OrthodonticReferralTreatmentApi';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';

interface IOrthodonticReferralTreatmentInformation {
    orthodonticReferralICD10Codes?: IOrthodonticReferralICD10Code[];
    canAddOrthodonticReferralICD10CodeMapping: boolean;
    canDeleteOrthodonticReferralICD10CodeMapping: boolean;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
    orthodonticReferralId: number;
    orthodonticReferralStatusId: number;
    canReportTreatments?: boolean;
    minimumTreatmentDate?: Date;
    treatments?: IOrthodonticReferralPatientTreatment[];
    hasRoleAllmantandvard: boolean;
    hasRoleOrtodontisttandvård: boolean;
    orthodonticReferralTherapy?: IOrthodonticReferralTherapy;
    isICD10CodeAndTherapyRequired: boolean;
    referralClosedDate?: Date;
}

export const OrthodonticReferralTreatmentInformation: React.FunctionComponent<IOrthodonticReferralTreatmentInformation> = ({ orthodonticReferralICD10Codes, canAddOrthodonticReferralICD10CodeMapping, canDeleteOrthodonticReferralICD10CodeMapping, getOrthodonticReferral, orthodonticReferralId, orthodonticReferralStatusId, canReportTreatments, minimumTreatmentDate, treatments, hasRoleAllmantandvard, hasRoleOrtodontisttandvård, orthodonticReferralTherapy, isICD10CodeAndTherapyRequired, referralClosedDate }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralTreatmentApi(auth);
    const [successMessage, setSuccessMessage] = React.useState<string>();
    const [therapies, setTherapies] = React.useState<IListItem[]>();

    React.useEffect(() => {
        getTherapies();
    }, [])

    const changeSuccessMessage = (message: string) => {
        const newMessage = setMessage(message, successMessage ?? "");
        setSuccessMessage(newMessage);
    }

    const getTherapies = () => {
        api.getTherapies((newTherapies) => {
            const data = newTherapies.map<IListItem>((therapy) => { return { text: therapy.description, value: therapy.orthodonticReferralTherapyId.toString() } });
            setTherapies(data)
        });
    }

    const saveOrthodonticReferralTherapy = (orthodonticReferralTherapyId: number) => {
        const data: IAddOrthodonticReferralTherapy = { orthodonticReferralId: orthodonticReferralId, orthodonticReferralTherapyId: orthodonticReferralTherapyId };
        api.saveOrthodonticReferralTherapy(data, () => {
            changeSuccessMessage("Terapi har sparats");
            getOrthodonticReferral(orthodonticReferralId, true);
        })
    }

    return (
        <>
            <div className="row">
                <h5 className="col-6">Vårdrapportering</h5>
            </div>
            <div className="row">
                <div className="col-12">
                    <AlertMessage duration={3000} alertType={AlertType.success}>{successMessage}</AlertMessage>
                    <div className="row">
                        <div className="col-6">
                            {
                                canAddOrthodonticReferralICD10CodeMapping ?
                                    <Select options={therapies ?? []} name="orthodonticReferralTherapyId" selectedValue={orthodonticReferralTherapy?.orthodonticReferralTherapyId.toString()} label="Terapi" isLoading={therapies === undefined} inlineLabel placeholder="Välj terapi" onChange={(val) => saveOrthodonticReferralTherapy(parseInt(val))} />
                                    : orthodonticReferralTherapy ?
                                        <TextInput name="therapyReadonly" label="Terapi" defaultValue={orthodonticReferralTherapy?.description ?? ""} readonly inlineLabel />
                                        : null
                            }
                        </div>
                    </div>
                    {
                        orthodonticReferralId && ((orthodonticReferralICD10Codes && orthodonticReferralICD10Codes.length > 0) || canAddOrthodonticReferralICD10CodeMapping) ?
                            <OrthodonticReferralICD10Codes getOrthodonticReferral={getOrthodonticReferral} canAddOrthodonticReferralICD10CodeMapping={canAddOrthodonticReferralICD10CodeMapping} orthodonticReferralICD10Codes={orthodonticReferralICD10Codes} orthodonticReferralId={orthodonticReferralId} changeSuccessMessage={changeSuccessMessage} canDeleteOrthodonticReferralICD10CodeMapping={canDeleteOrthodonticReferralICD10CodeMapping} />
                            : null
                    }
                    {
                        !isICD10CodeAndTherapyRequired ?
                            <OrthodonticReferralTreatments hasRoleAllmantandvard={hasRoleAllmantandvard}
                                hasRoleOrtodontisttandvard={hasRoleOrtodontisttandvård}
                                canReportTreatments={canReportTreatments}
                                minimumTreatmentDate={minimumTreatmentDate}
                                orthodonticReferralId={orthodonticReferralId ?? 0}
                                orthodonticReferralStatusId={orthodonticReferralStatusId ?? 0}
                                getOrthodonticReferral={getOrthodonticReferral}
                                treatments={treatments}
                                isICD10CodeAndTherapyRequired={isICD10CodeAndTherapyRequired}
                                referralClosedDate={referralClosedDate}
                            />
                            : null
                    }
                </div>
            </div>
            <hr />
        </>
    )
}